import { INewbuilding } from '../../types/newbuilding';
import { IApplicationState } from '../../types/redux';

export function selectNewbuilding(state: IApplicationState): INewbuilding {
  return state.newbuildingData.newbuilding;
}
